<div class="offerCreationHead" id="viewconfigDiv" [ngClass]="{'disabled-edit': lockEdit}"
    style="display: flex;flex-direction: column;width: 100%;height: 100%;font-size: 14px;overflow: hidden;"
    data-widget-name="GIFTCODE CREATION/EDITING">

    <div
        style="width: 100%;height: 100%; display: flex; align-items: stretch; flex-direction: column; overflow: hidden;">
        <div *ngIf="!showViewForCouponPool">
            <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;height: 80px;">
                <div class="qb-ml-20">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div
                    style="display: flex;flex-direction:column; width: 50%;justify-content: flex-end; align-items: center;">
                    <div style="display: flex;width: 100%;justify-content: flex-end; align-items: center;"  *ngIf="!previewmode">
                        <div style="display: flex;width: 100%;justify-content: flex-end;    align-items: center;">

                            <button class="primary-button" appButtonDebounce [throttleTime]="600"
                                style="margin-right: 15px;" (throttledClick)="sendGiftCode();"
                                data-button-name="Send Gift Code" *ngIf="(saveAndScheduleButtonLoading==false) "
                                [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                                [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('OFFER_PAGE.SEND_GIFT_CODE' | i18nTranslate)"
                                [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
                                >
                                <span class="normText"
                                    style="color: #fff; margin-left: 3px;">{{'OFFER_PAGE.SEND_GIFT_CODE' |
                                    i18nTranslate}}</span>
                            </button>
                            <button class="schedule-rectangle" *ngIf="saveAndScheduleButtonLoading==true">
                                <div
                                    style="display: flex;justify-content: center;width: 100%;height: 100%;align-items: center; ">
                                    <mat-spinner diameter="18" color="accent"></mat-spinner>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div style="display: flex;width: 100%;justify-content: flex-end; align-items: center;"  *ngIf="previewmode">
                        <div style="display: flex;width: 100%;justify-content: flex-end;    align-items: center;">

                            <button class="primary-button" appButtonDebounce [throttleTime]="600"
                                style="margin-right: 15px;" (throttledClick)="saveGiftCode();"
                                data-button-name="Send Gift Code"
                                [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                                [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('OFFER_PAGE.SAVE_GIFTCODE' | i18nTranslate)"
                                [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
                                >
                                <span class="normText"
                                    style="color: #fff; margin-left: 3px;">{{'OFFER_PAGE.SAVE_GIFTCODE' |
                                    i18nTranslate}}</span>
                            </button>
                            <!-- <button class="schedule-rectangle" *ngIf="saveAndScheduleButtonLoading==true">
                                <div
                                    style="display: flex;justify-content: center;width: 100%;height: 100%;align-items: center; ">
                                    <mat-spinner diameter="18" color="accent"></mat-spinner>
                                </div>
                            </button> -->
                        </div>
                    </div>

                    <div class="fontExo-13p" style="height:15px">

                    </div>
                </div>

            </div>
        </div>
       

        <div class="offer-card" [ngClass]="{'padding-none': showViewForCouponPool}">
            <div class="offer-details-card" [ngClass]="{'padding-border-radius-none': showViewForCouponPool}">
                <div [ngClass]="{'pointerevents-none':adminMode || managerAdmin}">
                    <div *ngIf="!showViewForCouponPool" class="label-title">{{'OFFER_PAGE.GIFT_CODE_DETAILS' | i18nTranslate}}<span
                            class="qb-imp-color">*</span></div>
                    <div class="qb-wrapper-input-data">
                        <div style="width:50%; margin-top: 16px; margin-bottom: 16px;">
                            <div class="label-subtitle">{{'OFFER_PAGE.GIFT_CODE_NAME_1' | i18nTranslate}}<span
                                    class="qb-imp-color">*</span></div>
                            <div style="width: 100%;">
                                <div class="formDiv" style="    width: 95%;    background: #F5F6FA;"
                                    [ngClass]="{active:submitClicked&&(offerTemplateName.length<1)}">
                                    <input class="formInput" type="text"
                                        placeholder="GiftCode Name (Minimum 3 characters)" maxlength="100"
                                        [(ngModel)]="offerTemplateName"
                                        *ngIf="!previewmode && !adminMode && !managerAdmin"
                                        (keyup)="onKeyOfferNameCheck($event)">
                                    <div *ngIf="previewmode || adminMode || managerAdmin" style="width: 100%;"
                                        [matTooltip]="'COMMON_PAGE.PREVIEW_ONLY' | i18nTranslate"><input
                                            class="formInput" type="text" placeholder="GiftCode Name" maxlength="100"
                                            [(ngModel)]="offerTemplateName" disabled></div>

                                    <span class="charText" style="color:#636466 ;"> {{offerTemplateName.length}} <span
                                            class="charText">/100</span> </span>
                                </div>
                                <div class="fontExo-13p" style="height:15px;color:red">
                                    <small style="color:red"
                                        *ngIf="submitClicked&&offerTemplateName.length<1">{{'OFFER_PAGE.GIFT_CODE_TEMPLATE_NAME_REQ'
                                        | i18nTranslate}}</small>
                                    <small style="color:red"
                                        *ngIf="submitClicked&&offerTemplateName.length<3&&offerTemplateName.length>0">{{'OFFER_PAGE.MIN_3_CHARACTER'
                                        | i18nTranslate}}</small>
                                </div>
                                <div *ngIf="isofferNameCheckLoading && offerTemplateName.length>=3 && !lockEdit"
                                    style="height:15px;color:rgba(34, 34, 34, 0.6);">
                                    <span style="display: flex;align-items: center;">Validating Gift Code
                                        Name<mat-spinner diameter="15"></mat-spinner></span>
                                </div>
                                <div
                                    *ngIf="!isofferNameCheckLoading && offerNameCheckInitialised && offerTemplateName.length>=3 && !lockEdit">
                                    <div *ngIf="!offerNameDuplicate" style="height:15px;color:green">
                                        {{'OFFER_PAGE.GIFT_CODE_TEMPLATE_NAME_VERIFIED' | i18nTranslate}}</div>
                                    <div *ngIf="offerNameDuplicate" style="height:15px;color:red">
                                        {{'OFFER_PAGE.USE_ANOTHER_GIFTCODE_TEMPLATE_NAME' | i18nTranslate}}</div>
                                </div>

                            </div>
                        </div>


                        <div style="width:50%; margin-bottom: 16px; margin-top: 16px;">
                            <div class="label-subtitle">Alias {{'OFFER_PAGE.GIFT_CODE_NAME_1' | i18nTranslate}}</div>
                            <div style="width: 100%;">
                              <div class="formDiv" style="    width: 95%;    background: #F5F6FA;">
                                <input class="formInput" type="text" placeholder="GiftCode Name (Minimum 3 characters)" maxlength="100"
                                  [(ngModel)]="giftcodeAliasName" *ngIf="!adminMode && !managerAdmin">
                                <div *ngIf="adminMode || managerAdmin" style="width: 100%;" [matTooltip]="'COMMON_PAGE.PREVIEW_ONLY' | i18nTranslate"><input
                                    class="formInput" type="text" placeholder="GiftCode Name" maxlength="100"
                                    [(ngModel)]="giftcodeAliasName" disabled></div>
                
                                <span class="charText" style="color:#636466 ;"> {{giftcodeAliasName.length}} <span
                                    class="charText">/100</span> </span>
                              </div>
                              <div class="fontExo-13p" style="height:15px;color:red">
                                <small style="color:red"
                                  *ngIf="submitClicked&&giftcodeAliasName.length<3&&giftcodeAliasName.length>1">{{'OFFER_PAGE.MIN_3_CHARACTER' | i18nTranslate}}</small>
                              </div>
                            </div>
                          </div>

                          
                    </div>

                    <div *ngIf="!showViewForCouponPool" style="width: 100%; margin-bottom: 12px;"  >
                        <div class="label-subtitle">Gift Code Length<span
                            class="qb-imp-color">*</span></div>
                        <div style="width:15%;" [ngClass]="{'cursor-notallowed':previewmode }" >
                            <div [ngClass]="{'pointerevents-none':previewmode }">
                                <div style="width: 100%;display: flex;align-items: center;">
                                    <div class="formDiv2" id="loyaltyPoints"
                                        [ngClass]="{active:submitClicked&&((codeLength==null)||(codeLength!=null&&(codeLength<4||codeLength=='e'||codeLength>20)))}"
                                        style="width: 100%;display: flex;">
                                        <input class=" formInput fontExo2" type="text" min=0 [(ngModel)]="codeLength"
                                            (keydown)="keypressNumber($event)">
                                    </div>
                                </div>
                                <div class="fontExo2 qb-error-msg"
                                    *ngIf="codeLength!=null&&(codeLength<4||codeLength>20)">
                                    <span>Gift code length: 4-20 characters.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div>
                        <div class="qb-check-container" [ngClass]="{'cursor-notallowed':previewmode }" >
                          <div class="flex-check" [ngClass]="{'pointerevents-none':previewmode }">
                            <mat-checkbox class="margin-left-10" color="primary" [(ngModel)]="isAutoreserve">
                               Coupon Visibility
                            </mat-checkbox>
                          </div>
                        </div>
                        <div
                        class="qb-show-warning" *ngIf="isAutoreserve"
                      >
                        <div>
                          <span
                            class="qb-i-div-schedule-offer2"
                            popoverClass="qb-my-custom-class"
                            placement="bottom"
                          >
                            i
                          </span>
                        </div>
                        <div >
                          <div>
                            <span class="qb-celeb-caution"
                              >
                              This code is visible to targeted customers by default
                            </span>
                          </div>
                        </div>
                      </div>
                      </div> -->


                    <!-- Targeted Audience type and selection -->

                    <hr id="1" *ngIf="!showViewForCouponPool">
                    <div style="width: 100%;" [ngClass]="{'cursor-notallowed':previewmode }" *ngIf="!showViewForCouponPool">
                        <div class="label-title">{{'OFFER_PAGE.TARGETED_AUDIENCE' | i18nTranslate}}<span
                                class="qb-imp-color">*</span></div>
                        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [ngClass]="{'pointerevents-none':previewmode }"
                            [(ngModel)]="giftCodeTargetAudience" (change)="giftCodeTypeRadioChange($event.value)">
                            <mat-radio-button color="primary" class="example-radio-button" value="INDIVIDUAL_CUSTOMER">
                                {{'OFFER_PAGE.INDIVIDUAL_CUSTOMER' | i18nTranslate}}
                            </mat-radio-button>
                            <mat-radio-button color="primary" class="example-radio-button" value="CUSTOMER_SEGMENTS">
                                {{'OFFER_PAGE.CUSTOMER_SEGMENTS_TIER_LIST' | i18nTranslate}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>


                    <div *ngIf="!showViewForCouponPool && giftCodeTargetAudience=='CUSTOMER_SEGMENTS'" style="width: 40%; padding: 15px 0px;" [ngClass]="{'cursor-notallowed':previewmode }">
                        <div class="qb-customer-segments" [formGroup]="templateDispatchForm">
                            <div class="label-title">
                                <span>{{'OFFER_PAGE.CUSTOMER_SEGEMNTS_TIER' | i18nTranslate}}</span>
                            </div>
                            <div class="qb-flex qb-full-width" [ngClass]="{'pointerevents-none':previewmode }">
                                <div class="qb-form-div-schedule qb-full-width cursor-pointer"
                                    style="margin-right: 12px;" (click)="selectopenclose('customerSegmentsSelect')">
                                    <mat-select #customerSegmentsSelect (selectionChange)="changeSegmentSelection()"
                                        class="qb-font-exo2" color="primary"
                                        placeholder="Select customer segment/tiers/lists"
                                        formControlName="dispatchcustomerSegments" multiple disableOptionCentering
                                        panelClass="myPanelClass">
                                        <div class="qb-dropdown-wrapper">
                                            <div class="qb-rectangle">
                                                <div class="qb-rect">
                                                    <mat-icon class="qb-icon" matPrefix>search </mat-icon>
                                                    <input class="qb-no-border-input" type="text"
                                                        formControlName="tempsegmentFilter"
                                                        placeholder=" Search by name "
                                                        (keydown)="$event.stopPropagation()" />
                                                </div>
                                            </div>
                                            <div class="qb-dropdown-scroll-wrapper">
                                                <div class="qb-scrollable-conatiner">
                                                    <div class="qb-mat-select-dropdowns">
                                                        <mat-option *ngFor="
                                          let segment of allcustomerObj
                                            | labelPipe
                                              : tempsegmentFilter
                                                  .value
                                              : 'name'
                                        " [value]="segment.id"
                                                            [disabled]="disableAllCustomerSelection && segment.id === 'ALL_CUSTOMERS'"
                                                            class="qb-font-exo2" [value]="segment.id">
                                                            {{ segment.name }}
                                                        </mat-option>

                                                        <div class="category-text-container"
                                                            *ngIf="customerSegmentList.length > 0">
                                                            <div class="category-line"></div>
                                                            <span class="category-text">{{'OFFER_PAGE.SEGMENTS' |
                                                                i18nTranslate}}</span>
                                                            <div class="category-line"></div>
                                                        </div>
                                                        <!-- Store Created Segments Section -->
                                                        <div
                                                            *ngIf="(storeCreatedSegments | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name').length>0">
                                                            <div class="qb-admin-store-lists">
                                                                <span class="category-text">{{ isAdminPos ? 'Admin
                                                                    Created Segments' : 'Store Created Segments'
                                                                    }}</span>
                                                            </div>
                                                            <ng-container
                                                                *ngFor="let segment of storeCreatedSegments | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name'">
                                                                <mat-option class="qb-font-exo2" [value]="segment.id"
                                                                    [disabled]="disableCustomerSegmentSelection || !segment.isActive"
                                                                    [matTooltip]="segment.isActive ? '' : 'We are preparing your segment. It will be available for use shortly'">
                                                                    {{ segment.name }}
                                                                </mat-option>
                                                            </ng-container>
                                                        </div>

                                                        <!-- Other Segments Section -->
                                                        <div
                                                            *ngIf="(otherSegments | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name').length>0">
                                                            <div class="qb-other-lists">
                                                                <span class="category-text">Other Segments</span>
                                                            </div>
                                                            <ng-container
                                                                *ngFor="let segment of otherSegments | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name'">
                                                                <mat-option class="qb-font-exo2" [value]="segment.id"
                                                                    [disabled]="disableCustomerSegmentSelection || !segment.isActive"
                                                                    [matTooltip]="segment.isActive ? '' : 'We are preparing your segment. It will be available for use shortly'">
                                                                    {{ segment.name }}
                                                                </mat-option>
                                                            </ng-container>
                                                        </div>

                                                        <div class="category-text-container"
                                                            *ngIf="customerTierList.length > 0">
                                                            <div class="category-line"></div>
                                                            <span class="category-text">{{'OFFER_PAGE.TIERS' |
                                                                i18nTranslate}}</span>
                                                            <div class="category-line"></div>
                                                        </div>
                                                        <mat-option class="qb-font-exo2" *ngFor="
                                          let segment of customerTierList
                                            | labelPipe
                                              : templateDispatchForm?.controls.tempsegmentFilter
                                                  .value
                                              : 'name'
                                        " [value]="segment.id" [disabled]="
                                          disableCustomerSegmentSelection ||
                                          !segment['isActive']
                                        " [matTooltip]="
                                          segment['isActive']
                                            ? ''
                                            : 'We are preparing your tiers. It will be available for use shortly'
                                        ">
                                                            {{ segment.name }}
                                                        </mat-option>
                                                        <div class="category-text-container"
                                                            *ngIf="customerList.length > 0">
                                                            <div class="category-line"></div>
                                                            <span class="category-text">{{'COMMON_PAGE.CUSTOMER_LIST' |
                                                                i18nTranslate}}</span>
                                                            <div class="category-line"></div>
                                                        </div>

                                                        <!-- Store Created Custom List Section -->
                                                        <div
                                                            *ngIf="(storeCreatedCustomList | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name').length>0">
                                                            <div class="qb-admin-store-lists">
                                                                <span class="category-text">
                                                                    {{ isAdminPos ? 'Admin Created List' : 'Store
                                                                    Created List' }}
                                                                </span>
                                                            </div>
                                                            <ng-container
                                                                *ngFor="let segment of storeCreatedCustomList | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name' ">
                                                                <mat-option class="qb-font-exo2" [value]="segment.id"
                                                                    [disabled]="disableCustomerSegmentSelection || !segment.isActive"
                                                                    [matTooltip]="segment.isActive ? '' : 'We are preparing your custom list. It will be available for use shortly'">
                                                                    {{ segment.name }}
                                                                </mat-option>
                                                            </ng-container>
                                                        </div>

                                                        <!-- Other Custom Lists Section -->
                                                        <div
                                                            *ngIf="(otherCustomList| labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name').length>0">
                                                            <div class="qb-other-lists">
                                                                <span class="category-text">Other Lists</span>
                                                            </div>
                                                            <ng-container
                                                                *ngFor="let segment of otherCustomList | labelPipe : templateDispatchForm?.controls.tempsegmentFilter.value : 'name'">
                                                                <mat-option class="qb-font-exo2" [value]="segment.id"
                                                                    [disabled]="disableCustomerSegmentSelection || !segment.isActive"
                                                                    [matTooltip]="segment.isActive ? '' : 'We are preparing your custom list. It will be available for use shortly'">
                                                                    {{ segment.name }}
                                                                </mat-option>
                                                            </ng-container>
                                                        </div>


                                                        <div class="category-text-container"
                                                            *ngIf="employeeList.length > 0">
                                                            <div class="category-line"></div>
                                                            <span class="category-text">{{'COMMON_PAGE.EMPLOYEE_LIST' |
                                                                i18nTranslate}}</span>
                                                            <div class="category-line"></div>
                                                        </div>
                                                        <mat-option class="qb-font-exo2" *ngFor="
                                          let segment of employeeList
                                            | labelPipe
                                              : tempsegmentFilter
                                                  .value
                                              : 'name'
                                        " [value]="segment.id" [disabled]="
                                          disableCustomerSegmentSelection ||
                                          !segment['isActive']
                                        " [matTooltip]="
                                          segment['isActive']
                                            ? ''
                                            : 'We are preparing your employee list. It will be available for use shortly'
                                        ">
                                                            {{ segment.name }}
                                                        </mat-option>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-select>
                                </div>
                                <div class="info-scl-container">
                                    <app-segmentation-customer-list-redirect
                                        [miniVer]="true"></app-segmentation-customer-list-redirect>
                                </div>
                            </div>

                            <mat-error class="qb-error text-align-left" *ngIf="
                                  !submitted &&
                                  templateDispatchForm?.controls.dispatchcustomerSegments
                                    .touched &&
                                    templateDispatchForm?.controls.dispatchcustomerSegments.hasError(
                                    'required'
                                  )
                                ">
                                {{'OFFER_PAGE.SEGMENT_TIER_REQ' | i18nTranslate}}</mat-error>
                            <mat-error class="qb-error" *ngIf="
                                  submitted &&
                                  templateDispatchForm?.controls.dispatchcustomerSegments
                                    .touched &&
                                    templateDispatchForm?.controls.dispatchcustomerSegments.hasError(
                                    'required'
                                  )
                                ">
                                {{'OFFER_PAGE.SEGMENT_TIER_REQ' | i18nTranslate}}</mat-error>
                        </div>
                    </div>
                    <div *ngIf="giftCodeTargetAudience=='INDIVIDUAL_CUSTOMER'"  [ngClass]="{'cursor-notallowed':previewmode }">
                        <button class="primary-button qb-create-new-offer-button" [ngClass]="{'pointerevents-none':previewmode }" (click)="selectCustomer()"
                            data-button-name="Select Customer">
                            {{ "OFFER_PAGE.SELECT_CUSTOMER" | i18nTranslate }}
                        </button>
                        <div *ngIf="selectedCustomerDetails" style="padding-top: 8px;">
                                <div class="each-filter">
                                  Selected Customer :  {{ selectedCustomerDetails.customerName }}
                                </div>
                        </div>
                    </div>

                    <!-- Select Type of Reward and their value -->

                    <hr id="3" *ngIf="!showViewForCouponPool">	
                    <div style="width: 100%;" [ngClass]="{'cursor-notallowed':previewmode }" >
                        <div class="label-title">{{'OFFER_PAGE.GIFT_CODE_TYPE' | i18nTranslate}}<span
                                class="qb-imp-color">*</span></div>
                        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [ngClass]="{'pointerevents-none':previewmode }"
                            [(ngModel)]="giftCodeType" (change)="giftCodeTypeRadioChange($event.value)">
                            <mat-radio-button color="primary" class="example-radio-button" value="EWALLET">
                                {{'OFFER_PAGE.EWALLET' | i18nTranslate}}
                            </mat-radio-button>
                            <mat-radio-button color="primary" class="example-radio-button" value="LOYALTY_POINTS">
                                {{'OFFER_PAGE.LOYALTY_POINTS' | i18nTranslate}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <hr id="4" *ngIf="giftCodeType=='EWALLET'">
                    <div style="width: 25%;" *ngIf="giftCodeType=='EWALLET'">
                        <div class="label-title">{{'OFFER_PAGE.SELECT_LEDGER' | i18nTranslate}}<span
                                class="qb-imp-color">*</span></div>
                                <div class="rp-name-inp-container">
                                    <mat-select [(ngModel)]="selectedLedgerId">
                                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">{{ledger.ledgerName}}</mat-option>
                                    </mat-select>
                                </div>
                    </div>
                
                    <app-wallet-expiry-configuration *ngIf="giftCodeType=='EWALLET'" #giftCodeWalletConfig [walletExpiryConfiguration]="walletExpiryConfiguration" [type]="'wallet'"></app-wallet-expiry-configuration>
                    <app-wallet-expiry-configuration *ngIf="giftCodeType=='LOYALTY_POINTS'" #profileLoyaltyConfig [loyaltyExpiryConfig]="loyaltyExpiryConfig" [type]="'loyalty'"></app-wallet-expiry-configuration>
                    <hr id="4">

                    <div style="width: 100%;">
                        <div class="label-title">{{'OFFER_PAGE.VALUE' | i18nTranslate}}<span
                                class="qb-imp-color">*</span></div>
                        <div class="label-subtitle">{{'OFFER_PAGE.DISCOUNT_VALUE' | i18nTranslate}} </div>

                        <div style="width:15%;">
                            <div *ngIf="giftCodeType=='LOYALTY_POINTS'">
                                <div style="width: 100%;display: flex;align-items: center;">
                                    <div class="formDiv2" id="loyaltyPoints"
                                        [ngClass]="{active:submitClicked && ((loyaltyPoints==null)||(loyaltyPoints!=null&&(loyaltyPoints<1||loyaltyPoints=='e')))}"
                                        style="width: 100%;display: flex;">
                                        <input class=" formInput fontExo2" type="text" min=0 [(ngModel)]="loyaltyPoints"
                                            (keydown)="keypressNumber($event)">
                                    </div>
                                    <span matSuffix [id]="'pvalue-'+i+'-'+j"
                                        style="font-size: 12px;margin: 0 8px;color: #3a3a3a;">
                                        Points</span>
                                </div>
                                <div class="fontExo2 qb-error-msg error-text"
                                    *ngIf="submitClicked && ((loyaltyPoints<1 || loyaltyPoints=='e' || loyaltyPoints == null))">
                                    <span>{{'OFFER_PAGE.ENTER_VALID_VALUE' | i18nTranslate}}</span>
                                </div>
                            </div>

                            <div *ngIf="giftCodeType=='EWALLET'">
                                <div style="width: 100%;display: flex;align-items: center;">
                                    <div class="formDiv2" id="eWallet"
                                        [ngClass]="{active:submitClicked&&(eWallet==null)||(eWallet!=null&&(eWallet<1||eWallet=='e'))}"
                                        style="width: 100%;display: flex;">
                                        <input class=" formInput fontExo2" type="text" min=0 [(ngModel)]="eWallet"
                                            (keydown)="keypressNumber($event)">
                                    </div>
                                    <span matSuffix [id]="'pvalue-'+i+'-'+j"
                                        style="font-size: 12px;margin: 0 8px;color: #3a3a3a;">
                                        {{currencySymbol}}</span>
                                </div>
                                <div class="fontExo2 qb-error-msg error-text" *ngIf="(!eWallet || (eWallet<1||eWallet=='e')) && submitClicked">
                                    <span>{{'OFFER_PAGE.ENTER_VALID_VALUE' | i18nTranslate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Select Channels -->

                    <!-- <hr id="5">
                    <div [ngClass]="{'cursor-notallowed':previewmode }">
                        <div class="qb-main"  [ngClass]="{'pointerevents-none':previewmode }">
                            <div class="qb-channel-div">
                                <div class="label-title">
                                    <span>{{'CAMPAIGN_PAGE.SELECT_CHANNEL' | i18nTranslate}}</span>
                                </div>
                                <div class="qb-d-flex" style="flex-direction: column;">
                                    <div class="channel-selector">
                                        <div *ngFor="let channel of channels">
                                            <div *ngIf="(validScreens | screenConfig: getId(channel))">
                                                <mat-checkbox color="primary" [checked]="isChannelChecked2(channel)"
                                                    (change)="checkChannel(channel)">{{channel === 'pushNotification' ?
                                                    'Push Notification' : channel}}</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="errorChannelSelect.length > 0" style="color: red; font-size: 11px;">
                                        {{errorChannelSelect}}
                                    </div>
                                </div>
                            </div>
                            <div class="qb-channel-div" *ngIf="selectedChannelList.length > 0">
                                <div class="label-title">
                                    <span>{{'OFFER_PAGE.CHANNEL' | i18nTranslate}}</span>
                                </div>
                                <div style="width: fit-content;">
                                    <div class="qb-sms-div">
                                        <span class="qb-selected-channel cursor-pointer"
                                            [ngClass]="{ active: selectedChannel?.toUpperCase()== 'SMS' }"
                                            (click)="selectChannel('SMS')" matTooltip="SMS" *ngIf="
                                     (validScreens | screenConfig: 18) && ((selectedChannelList.indexOf('SMS') != -1) || (selectedChannelList.indexOf('sms') != -1))
                                    ">
                                            <div style="display: flex; gap: 2px;">
                                                <img src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/sms.svg"
                                                    width="20px" height="20px">
                                                <span class="material-symbols-outlined" style="font-size: 20px; color: red;"
                                                    *ngIf="attachSmsError.length > 0 || (showSMSWarning != 1 && selectedChannelList.indexOf('sms') != -1 )">
                                                    error
                                                </span>
                                            </div>
                                        </span>
                                        <span *ngIf="isChannelChecked2('email')" class="qb-selected-channel cursor-pointer"
                                            [ngClass]="{ active: selectedChannel?.toUpperCase() == 'EMAIL' }"
                                            (click)="selectChannel('EMAIL')"
                                            [matTooltip]="'COMMON_PAGE.EMAIL' | i18nTranslate">
                                            <div style="display: flex; gap: 2px;">
                                                <img src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/email.svg"
                                                    width="20px" height="20px">
                                                <span class="material-symbols-outlined" style="font-size: 20px; color: red;"
                                                    *ngIf="attachEmailError.length > 0">
                                                    error
                                                </span>
                                            </div>
                                        </span>
                                        <span *ngIf="(validScreens | screenConfig: 41) && (isChannelChecked2('whatsapp'))"
                                            class="qb-selected-channel cursor-pointer"
                                            [ngClass]="{ active: selectedChannel?.toUpperCase() == 'WHATSAPP' }"
                                            (click)="selectChannel('WHATSAPP')"
                                            [matTooltip]="'COMMON_PAGE.WHATSAPP' | i18nTranslate">
                                            <div style="display: flex; gap: 2px;">
                                                <img src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/whatsapp.svg"
                                                    width="20px" height="20px">
                                                <span class="material-symbols-outlined" style="font-size: 20px; color: red;"
                                                    *ngIf="attachWhatsappError.length > 0">
                                                    error
                                                </span>
                                            </div>
                                        </span>
    
    
    
                                        <span *ngIf="isChannelChecked2('pushNotification')"
                                            class="qb-selected-channel cursor-pointer"
                                            [ngClass]="{ active: selectedChannel?.toUpperCase() == 'PUSHNOTIFICATION' }"
                                            (click)="selectChannel('PUSHNOTIFICATION')"
                                            [matTooltip]="'COMMON_PAGE.PUSHNOTIFICATION' | i18nTranslate">
                                            <div style="display: flex; gap: 2px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="20px"
                                                    viewBox="0 -960 960 960" width="20px" fill="#5f6368">
                                                    <path
                                                        d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z" />
                                                </svg>
                                                <span class="material-symbols-outlined" style="font-size: 20px; color: red;"
                                                    *ngIf="offerPushNotificationErrorText?.length > 0">
                                                    error
                                                </span>
    
                                            </div>
                                        </span>
    
                                    </div>
                                </div>
                            </div>
                            <div class="qb-full-width" *ngIf="selectedChannel?.toUpperCase() == 'EMAIL'">
    
                                <div class="qb-channel-div" *ngIf="selectedChannelList.length > 0">
                                    <div class="label-title">
                                        <span>{{'OFFER_PAGE.REWAED_TEMPLATE' | i18nTranslate}}</span>
                                    </div>
                                    <div class="qb-half-width">
                                        <div (click)="openchannelEmailDiv()" class="qb-view-summary"
                                            *ngIf="preemailLayoutId == null">
                                            {{'OFFER_PAGE.ATTACT_REWARD_EMAIL' | i18nTranslate}}
                                        </div>
                                        <div *ngIf="attachEmailError.length > 0" style="color: red; font-size: 11px;">
                                            {{attachEmailError}}
                                        </div>
                                        <div (click)="openchannelEmailDiv()" class="qb-view-summary"
                                            *ngIf="preemailLayoutId > 0">
                                            {{'OFFER_PAGE.REPLACE_REWARD_EMAIL' | i18nTranslate}}
                                        </div>
    
                                        <div class="qb-flex cursor-pointer" style="margin-top: 5px;" (click)="opensnapshotHtmlDialog()"
                                            *ngIf="preemailLayoutId">
                                            <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
                                                role="img" class="qb-attach-file" aria-hidden="true"
                                                *ngIf="preemailLayoutId">attach_file</mat-icon><span
                                                class="qb-challenge-template" style="margin-top: 3px;">{{
                                                preemailLayoutName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="qb-full-width" *ngIf="selectedChannel?.toUpperCase() == 'SMS'">
                                <div class="qb-channel-div" *ngIf="selectedChannelList.length > 0">
                                    <div class="label-title">
                                        {{'OFFER_PAGE.REWARD_SMS_TEMPLATE' | i18nTranslate}}
                                    </div>
                                    <div class="qb-half-width">
                                        <div (click)="openchannelSMSDiv('reward')" class="qb-view-summary"
                                            *ngIf="presmsrewardId == null">
                                            {{'OFFER_PAGE.ATTACH_REWARD_SMS' | i18nTranslate}}
                                        </div>
                                        <div *ngIf="attachSmsError.length > 0" style="color: red; font-size: 11px;">
                                            {{attachSmsError}}</div>
                                        <div (click)="openchannelSMSDiv('reward')" class="qb-view-summary"
                                            *ngIf="presmsrewardId > 0">
                                            {{'OFFER_PAGE.REPLACE_REWARD_SMS' | i18nTranslate}}
                                        </div>
    
    
                                        <div class="qb-flex cursor-pointer" *ngIf="presmsrewardId" (click)="opensmsPreviewDialog(presmsrewardId)">
                                            <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
                                                role="img" class="qb-attach-file" aria-hidden="true"
                                                *ngIf="presmsrewardId">attach_file</mat-icon><span
                                                class="qb-challenge-template">{{
                                                presmsrewadLayoutName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="qb-full-width" *ngIf="selectedChannel?.toUpperCase() == 'WHATSAPP'">
                                <div class="qb-channel-div" *ngIf="selectedChannelList.length > 0">
                                    <div class="label-title">
                                        {{'OFFER_PAGE.REWARD_WHATSAPP_TEMPLATE' | i18nTranslate}}
                                    </div>
                                    <div class="qb-half-width">
                                        <div style="width: 175px;" (click)="openchannelWhatsappDiv()"
                                            class="qb-view-summary" *ngIf="prewhatsappLayoutId == null">
                                            {{'OFFER_PAGE.ATTACH_REWARD_TEMPLATE' | i18nTranslate}}
                                        </div>
                                        <div *ngIf="attachWhatsappError.length > 0" style="color: red; font-size: 11px;">
                                            {{attachWhatsappError}}</div>
                                        <div style="width: 175px;" (click)="openchannelWhatsappDiv()"
                                            class="qb-view-summary" *ngIf="prewhatsappLayoutId > 0">
                                            {{'OFFER_PAGE.REPLACE_REWARD_TEMPLATE' | i18nTranslate}}
                                        </div>
    
                                        <div class="qb-flex cursor-pointer" *ngIf="prewhatsappLayoutId"   (click)="openWhatsAppPreview(prewhatsappLayoutData)" > 
                                            <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
                                                role="img" class="qb-attach-file" aria-hidden="true"
                                                *ngIf="prewhatsappLayoutId">attach_file</mat-icon><span
                                                class="qb-challenge-template">{{
                                                prewhatsappLayoutName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="selectedChannelList.length > 0 && preemailLayoutId && selectedChannel?.toUpperCase() == 'EMAIL'"
                                class="qb-full-width subject-container">
                                <div class="label-title padding-top-5">Offer Email Subject
    
                                </div>
                                <div class="position-relative flex-grow-1">
                                    <div class="pos-relative qb-full-width formDiv" style="width: 50%;background: #F5F6FA;">
                                        <input type="text" (keydown)="stringInputHandler($event, 150)"
                                            [(ngModel)]="offerEmailSubject" maxlength="150" #inp2
                                            class="formInput qb-full-width" placeholder="Enter Subject"
                                            [ngClass]="{'error-border':isSegmentNameInvalid}">
                                        <div class="remaining-text-left-2">
                                            {{inp2.value.length}}/{{inp2.getAttribute('maxlength')}}</div>
                                    </div>
                                    <div *ngIf="offerEmailSubjectErrorText" class="qb-error-text">
                                        {{offerEmailSubjectErrorText}}</div>
                                </div>
                            </div>
    
                            <div *ngIf="selectedChannelList.length > 0 && selectedChannel?.toUpperCase() == 'PUSHNOTIFICATION'"
                                class="qb-full-width subject-container">
                                <div class="label-subtitle padding-top-5">
                                    Push Notification Title
                                </div>
                                <div class="position-relative flex-grow-1">
                                    <div class="pos-relative qb-full-width formDiv" style="width: 50%;background: #F5F6FA;">
                                        <input type="text" (keydown)="stringInputHandler($event, 150)"
                                            [(ngModel)]="offerPushNotificationSubject" maxlength="150" #inpTitle
                                            class="formInput qb-full-width" placeholder="Enter Title"
                                            [ngClass]="{'error-border':isSegmentNameInvalid}">
                                        <div class="remaining-text-left-2">
                                            {{inpTitle.value.length}}/{{inpTitle.getAttribute('maxlength')}}</div>
                                    </div>
                                    <div *ngIf="offerPushNotificationErrorText" class="qb-error-text">
                                        {{offerPushNotificationErrorText}}</div>
                                </div>
                            </div>
                            <div *ngIf="selectedChannelList.length > 0 && selectedChannel?.toUpperCase() == 'PUSHNOTIFICATION'"
                                class="qb-full-width subject-container">
                                <div class="label-subtitle padding-top-5">
                                    Push Notification Alias Title
                                </div>
                                <div class="position-relative flex-grow-1">
                                    <div class="pos-relative qb-full-width formDiv" style="width: 50%;background: #F5F6FA;">
                                        <input type="text" (keydown)="stringInputHandler($event, 150)"
                                            [(ngModel)]="offerPushTitleAlias" maxlength="150" #inpAlias
                                            class="formInput qb-full-width" placeholder="Enter Title"
                                            [ngClass]="{'error-border':isSegmentNameInvalid}">
                                        <div class="remaining-text-left-2">
                                            {{inpAlias.value.length}}/{{inpAlias.getAttribute('maxlength')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="selectedChannelList.length > 0 && selectedChannel?.toUpperCase() == 'PUSHNOTIFICATION'"
                                class="qb-full-width subject-container">
                                <div class="label-subtitle padding-top-5">
                                    Push Notification Body
                                </div>
                                <div class="position-relative flex-grow-1">
                                    <div class="pos-relative qb-full-width formDiv" style="width: 50%;background: #F5F6FA;">
                                        <input type="text" (keydown)="stringInputHandler($event, 150)"
                                            [(ngModel)]="offerPushNotificationBody" maxlength="150" #inpBody
                                            class="formInput qb-full-width" placeholder="Enter Body"
                                            [ngClass]="{'error-border':isSegmentNameInvalid}">
                                        <div class="remaining-text-left-2">
                                            {{inpBody.value.length}}/{{inpBody.getAttribute('maxlength')}}</div>
                                    </div>
                                </div>
                            </div>
    
                            <div *ngIf="isNonDiscountTypeEmailPicked && selectedChannel?.toUpperCase() == 'EMAIL' && !channelConfigureStatus && preemailLayoutId"
                                class="warn-text">
                                <span class="material-symbols-outlined">
                                    warning
                                </span>You have selected custom template. Please ensure all the merge tags are relevant to
                                the offer, Otherwise they won't be replaced in the final communication.
                                If you are unsure, we suggest to remove the merge tags and replace it with your text.
                            </div>
                            <div *ngIf="isNonDiscountTypeSMSPicked  && selectedChannel?.toUpperCase() == 'SMS' && !channelConfigureStatus && presmsrewardId"
                                class="warn-text">
                                <span class="material-symbols-outlined">
                                    warning
                                </span>You have selected custom template. Please ensure all the merge tags are relevant to
                                the offer, Otherwise they won't be replaced in the final communication.
                                If you are unsure, we suggest to remove the merge tags and replace it with your text.
                            </div>
                        </div>
                    </div> -->




                    <hr id="7">
                    <div style="width: 100%;" class="qb-gap-component"  [ngClass]="{'cursor-notallowed':previewmode }">
                        <div>
                            <div class="label-title">{{'OFFER_PAGE.REWARD_VALIDITY' | i18nTranslate}}<span
                                    class="qb-imp-color">*</span></div>
                        </div>
                        <!-- <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                            [(ngModel)]="giftCodeValidityType" (change)="giftCodeTypeRadioChange($event.value)">
                            <mat-radio-button color="primary" class="example-radio-button" value="NO_OF_DAYS">
                                {{'OFFER_PAGE.NO_OF_DAYS' | i18nTranslate}}
                            </mat-radio-button>
                            <mat-radio-button color="primary" class="example-radio-button" value="SPECIFIC_DAYS">
                                {{'OFFER_PAGE.SPECIFIC_DATE' | i18nTranslate}}
                            </mat-radio-button>
                        </mat-radio-group> -->

                        <!-- <div style="width:100%;" class="qb-gap-component" *ngIf="giftCodeValidityType=='NO_OF_DAYS'">
                            <span class="label-subtitle">{{'OFFER_PAGE.REWARD_VALID_FOR' | i18nTranslate}}</span>
                            <div style="width:50%;">

                                <div style="width: 20%;display: flex;align-items: center;">
                                    <div class="formDiv2"
                                        [ngClass]="{active:submitClicked&&(rewardTimeToComplete==null)||(rewardTimeToComplete!=null&&(rewardTimeToComplete<1||rewardTimeToComplete=='e'))}"
                                        style="width: 100%;">
                                        <input class="formInput fontExo2" min=1 type="number" id="scrollPreventInput"
                                            maxlength="3" [(ngModel)]="rewardTimeToComplete"
                                            (keydown)="numberInputHandler($event,3)">
                                    </div>
                                    <span matSuffix [id]="'pvalue-'+i+'-'+j"
                                        style="font-size: 12px;margin: 0 8px;color: #3a3a3a;"
                                        *ngIf="rewardTimeToComplete>1">
                                        {{'OFFER_PAGE.DAYS' | i18nTranslate}}</span>
                                    <span matSuffix [id]="'pvalue-'+i+'-'+j"
                                        style="font-size: 12px;margin: 0 8px;color: #3a3a3a;"
                                        *ngIf="rewardTimeToComplete<2">
                                        {{'OFFER_PAGE.DAY' | i18nTranslate}}</span>

                                </div>
                                <div class="fontExo2 qb-error-msg"
                                    *ngIf="rewardTimeToComplete!=null&&(rewardTimeToComplete<1||rewardTimeToComplete=='e')">

                                    <span>{{'OFFER_PAGE.ENTER_VALID_VALUE' | i18nTranslate}}</span>

                                </div>
                            </div>
                            <small style="color:red"
                                *ngIf="submitClicked&&(rewardTimeToComplete==null)">{{'OFFER_PAGE.REWARD_VALIDITY_ERROR'
                                | i18nTranslate}}</small>
                        </div> -->

                        <div >
                            <div style="width: 30%" [ngClass]="{'pointerevents-none':previewmode }">
                                <span class="label-subtitle">{{'OFFER_PAGE.GIFT_CODE_VALID_TILL' | i18nTranslate}}</span>
                                <div style="width:50%; padding-top: 4px;">
                                    <mat-form-field appearance="fill" class="qb-full-width">
                                        <input matInput [matDatepicker]="picker"  [min]="startDateMinValue" [formControl]="expiryDate"  readonly 
                                        (click)="picker.open()" class="cursor-pointer">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <small style="color:red" class="error-text"
                                    *ngIf="submitClicked&&(expiryDate.invalid)">{{'OFFER_PAGE.GIFTCODE_VALIDITY_ERROR'
                                    | i18nTranslate}}</small>
                            </div>

                        </div>


                    </div>





                    <hr id="9">
                    <div style="width: 100%;" id='customDescription'>
                        <div class="label-title">Custom Description(Optional)</div>
                        <div class="label-subtitle"> </div>
                        <div>
                            <div style="width:100%; margin-top: 10px;">
                                <div>
                                    <div class="qb-d-flex qb-ai-center">
                                        <textarea class="bullet-textarea qb-w-100" [(ngModel)]="customDescription"
                                            (keydown)="handleKeyDown($event, 'description')"
                                            (focus)="initializeBulletPoint('description')"
                                            placeholder="Type here..."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr id="9">
                    <div style="width: 100%;" id='customAliasDescription'>
                        <div class="label-title">Alias Custom Description(Optional)</div>
                        <div class="label-subtitle"> </div>
                        <div>
                            <div style="width:100%; margin-top: 10px;">
                                <div>
                                    <div class="qb-d-flex qb-ai-center">
                                        <textarea class="bullet-textarea qb-w-100" [(ngModel)]="customAliasDescription"
                                            (keydown)="aliasHandleKeyDown($event, 'description')"
                                            (focus)="aliasInitializeBulletPoint('description')"
                                            placeholder="Type here..."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span>
                        <hr id="10">
                        <div style="width: 100%;" id='customTermsAndCondition'>
                            <div class="label-title">Custom Terms and Condition(Optional)</div>
                            <div class="label-subtitle"> </div>
                            <div>
                                <div style="width:100%; margin-top: 10px;">
                                    <div>
                                        <div class="qb-d-flex qb-ai-center">
                                            <textarea class="bullet-textarea qb-w-100"
                                                [(ngModel)]="customTermsAndCondition"
                                                (keydown)="handleKeyDown($event, 'terms')"
                                                (focus)="initializeBulletPoint('terms')"
                                                placeholder="Type here..."></textarea>
                                        </div>
                                    </div>
                                    <!-- <small style="color:red" *ngIf="submitClicked">{{'OFFER_PAGE.ENTER_VALID_VALUE' |
                                        i18nTranslate}}</small> -->
                                </div>
                            </div>
                        </div>
                    </span>

                    <span>
                        <hr id="10">
                        <div style="width: 100%;" id='customAliasTermsAndCondition'>
                            <div class="label-title">Alias Custom Terms and Condition(Optional)</div>
                            <div class="label-subtitle"> </div>
                            <div>
                                <div style="width:100%; margin-top: 10px;">
                                    <div>
                                        <div class="qb-d-flex qb-ai-center">
                                            <textarea class="bullet-textarea qb-w-100"
                                                [(ngModel)]="customAliasTermsAndCondition"
                                                (keydown)="aliasHandleKeyDown($event, 'terms')"
                                                (focus)="aliasInitializeBulletPoint('terms')"
                                                placeholder="Type here..."></textarea>
                                        </div>
                                    </div>
                                    <!-- <small style="color:red" *ngIf="submitClicked">{{'OFFER_PAGE.ENTER_VALID_VALUE' |
                                        i18nTranslate}}</small> -->
                                </div>
                            </div>
                        </div>
                    </span>

                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="channelConfigureStatus">
    <div class="overlay"></div>
    <div class="qb-config-status">
        <div class="qb-config-label-first configLabelSecond">
            <div>{{'OFFER_PAGE.CHOOSE_TEMPLATE' | i18nTranslate}}</div>
            <div>
                <mat-icon (click)="channelConfigureStatus = false" class="cursor-pointer">close</mat-icon>
            </div>
        </div>
        <div class="qb-seperator"></div>
        <div class="qb-select-channel">
            <div *ngIf="selectedChannel?.toUpperCase() == 'EMAIL'" class="qb-select-div">
                <mat-divider></mat-divider>
                <div>
                    <div class="qb-form-div-schedule qb-choose">
                        <input class="qb-form-input qb-fs08-rem" [(ngModel)]="filterEmail.label" type="text"
                            placeholder="Search by name" />
                    </div>
                    <div class="qb-choose-template-offerschedule" id="NewTemplateExt">
                        <div class="category-text-container" *ngIf="(offerDiscountTypeEmailTemplateList
            | labelPipe: filterEmail.label:'name').length != 0">
                            <div class="category-line"></div>
                            <span class="category-text">GiftCode Type Emails <span
                                    class="reco-text">Recommended</span></span>
                            <div class="category-line"></div>
                        </div>
                        <div *ngFor="
                let template of offerDiscountTypeEmailTemplateList
                  | labelPipe: filterEmail.label:'name';
                let i = index
              " class="qb-template-card-offer2" (click)="
                selectTemplate(
                  'EMAIL',
                  template['id'],
                  template['name'],
                  template['tableType']
                );
              " [style.border]="
                selectedEmailTemplateId == template['id']
                  ? '3px solid #5dadf9'
                  : '3px solid #FFF'
              ">
                            <div *ngIf="template != null" class="qb-layout">
                                <div class="qb-fs08-rem name-ellipsis" [matTooltip]="template['name']">
                                    {{ template.name }}
                                </div>
                                <div class="qb-fs08-rem qb-layout-name2">
                  <span class="qb-preview" (click)="opensnapshotHtmlDialog(template.id,template.tableType)">
                    {{"OFFER_PAGE.PREVIEW" | i18nTranslate}}</span>
                </div>
                            </div>
                        </div>
                        <div class="category-text-container" *ngIf="(otherEmailTemplateList
            | labelPipe: filterEmail.label:'name').length != 0">
                            <div class="category-line"></div>
                            <span class="category-text">Other Custom Emails</span>
                            <div class="category-line"></div>
                        </div>
                        <div *ngFor="
                let template of otherEmailTemplateList
                  | labelPipe: filterEmail.label:'name';
                let i = index
              " class="qb-template-card-offer2" (click)="
                selectTemplate(
                  'EMAIL',
                  template['id'],
                  template['name'],
                  template['tableType'],
                  true
                );
              " [style.border]="
                selectedEmailTemplateId == template['id']
                  ? '3px solid #5dadf9'
                  : '3px solid #FFF'
              ">
                            <div *ngIf="template != null" class="qb-layout">
                                <div class="qb-fs08-rem name-ellipsis" [matTooltip]="template['name']">
                                    {{ template.name }}
                                </div>
                                <div class="qb-fs08-rem qb-layout-name2">
                  <span class="qb-preview" (click)="opensnapshotHtmlDialog(template.id,template.tableType)">
                    {{"OFFER_PAGE.PREVIEW" | i18nTranslate}}</span>
                </div>
                            </div>
                        </div>
                        <div *ngIf="(offerDiscountTypeEmailTemplateList
              | labelPipe: filterEmail.label:'name').length == 0 && (otherEmailTemplateList
              | labelPipe: filterEmail.label:'name').length == 0" class="no-data">
                            {{'SHARED_PAGE.NO_DATA_AVAILABLE' | i18nTranslate}}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedChannel?.toUpperCase() == 'SMS'" class="qb-selected-channel2">
                <div>
                    <div class="qb-form-div-schedule qb-choose">
                        <input class="qb-form-input fs08-rem" [(ngModel)]="filter.label" type="text"
                            placeholder="Search by name" />
                    </div>
                    <div class="qb-choose-template-offer-schedule" id="NewTemplateExt">
                        <div class="category-text-container" *ngIf="(smsRewardTemplateList
            | labelPipe: filter.label:'name').length != 0">
                            <div class="category-line"></div>
                            <span class="category-text">GiftCode Type SMS <span
                                    class="reco-text">Recommended</span></span>
                            <div class="category-line"></div>
                        </div>
                        <div *ngFor="
                let layout of smsRewardTemplateList
                  | labelPipe: filter.label:'name';
                let i = index
              " class="qb-template-card-offer2" (click)="selectSMStemplateOBJ(layout, layout['id'])" [style.border]="
                selectedSmsTemporaryId == layout['id']
                  ? '3px solid #5dadf9'
                  : '3px solid #FFF'
              ">
                            <div *ngIf="layout != null" class="qb-layout">
                                <div class="qb-fs08-rem qb-layout-name2">
                                    <span [matTooltip]="layout['name']" matTooltipClass="ex-tooltip-red1">{{ layout.name
                                        | limitTo: 18
                                        }}</span>
                                </div>
                                <div class="qb-fs08-rem qb-layout-name2">
                  <span class="qb-preview" (click)="openSMSPreview(layout)">
                    {{'OFFER_PAGE.PREVIEW' | i18nTranslate}}</span>
                </div>
                            </div>
                        </div>
                        <div class="category-text-container" *ngIf="(customSmsTemplateList
            | labelPipe: filter.label:'name').length != 0">
                            <div class="category-line"></div>
                            <span class="category-text">Custom SMS</span>
                            <div class="category-line"></div>
                        </div>
                        <div *ngFor="
                let layout of customSmsTemplateList
                  | labelPipe: filter.label:'name';
                let i = index
              " class="qb-template-card-offer2" (click)="selectSMStemplateOBJ(layout, layout['id'],true)"
                            [style.border]="
                selectedSmsTemporaryId == layout['id']
                  ? '3px solid #5dadf9'
                  : '3px solid #FFF'
              ">
                            <div *ngIf="layout != null" class="qb-layout">
                                <div class="qb-fs08-rem qb-layout-name2">
                                    <span [matTooltip]="layout['name']" matTooltipClass="ex-tooltip-red1">{{ layout.name
                                        | limitTo: 18
                                        }}</span>
                                </div>
                                <div class="qb-fs08-rem qb-layout-name2">
                  <span class="qb-preview" (click)="openSMSPreview(layout)">
                    {{'OFFER_PAGE.PREVIEW' | i18nTranslate}}</span>
                </div>
                            </div>
                        </div>
                        <div *ngIf="(smsRewardTemplateList
            | labelPipe: filter.label:'name').length == 0 && (customSmsTemplateList
            | labelPipe: filter.label:'name').length == 0" class="no-data">
                            {{'SHARED_PAGE.NO_DATA_AVAILABLE' | i18nTranslate}}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedChannel?.toUpperCase() == 'WHATSAPP'" class="qb-selected-channel2">
                <div>
                    <div class="qb-form-div-schedule qb-choose">
                        <input class="qb-form-input fs08-rem" [(ngModel)]="filterWhatsApp.label" type="text"
                            placeholder="Search by name" />
                    </div>
                    <div class="qb-choose-template-offer-schedule" id="NewTemplateExt">
                        <div *ngFor="
                let layout of whatsAppTemplateList
                  | labelPipe: filterWhatsApp.label:'name';
                let i = index
              " class="qb-template-card-offer2" (click)="selectWhatsApptemplateOBJ(layout, layout['id'])"
                            [style.border]="
              selectedWhatsAppTemporaryId == layout['id']
                  ? '3px solid #4abb5975'
                  : '3px solid #FFF'
              ">
                            <div *ngIf="layout != null" class="qb-layout">
                                <div class="qb-fs08-rem qb-layout-name2">
                                    <span [matTooltip]="layout['name']" matTooltipClass="ex-tooltip-red1">{{ layout.name
                                        | limitTo: 40
                                        }}</span>
                                </div>
                                <div class="qb-fs08-rem qb-layout-name2">
                                    <span class="qb-preview" (click)="openWhatsAppPreview(layout['layoutData'])">
                                        {{'OFFER_PAGE.PREVIEW' | i18nTranslate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="qb-seperator" *ngIf="selectedChannel?.toUpperCase() == 'SMS' || 'WHATSAPP'"></div>
        <div class="qb-footer-labels qb-labels2" *ngIf="selectedChannel?.toUpperCase() == 'SMS'">
            <div class="qb-cancel-button" (click)="cancelSMSSave()">{{'OFFER_PAGE.CANCEL' | i18nTranslate}}</div>
            <div class="qb-confirm-button" (click)="onSMSSave('schedule')">
                {{'OFFER_PAGE.SAVE' | i18nTranslate}}
            </div>
        </div>
        <div class="qb-footer-labels qb-labels2" *ngIf="selectedChannel?.toUpperCase() == 'WHATSAPP'">
            <div class="qb-cancel-button" (click)="cancelWhatsAppSave()">{{'OFFER_PAGE.CANCEL' | i18nTranslate}}</div>
            <div class="qb-confirm-button" (click)="onWhatsAppSave()">
                {{'OFFER_PAGE.SAVE' | i18nTranslate}}
            </div>
        </div>
        <div class="qb-footer-labels qb-labels2" *ngIf="selectedChannel?.toUpperCase() == 'EMAIL'">
            <div class="qb-cancel-button" (click)="cancelEmailSave()">{{'OFFER_PAGE.CANCEL' | i18nTranslate}}</div>
            <div class="qb-confirm-button" (click)="onEmailSave()">
                {{'OFFER_PAGE.SAVE' | i18nTranslate}}
            </div>
        </div>
    </div>
</div>